module.exports = __webpack_public_path__ + "static/media/item_bgp3.62f0132c.png";